import { cards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
              分类浏览
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              按类型探索
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              从科幻到纪录，总有一个类型适合今天的你
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card) => (
              <article
                key={card.id}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    title={card.title}
                  />
                  <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                    {card.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}